import React, { useEffect, useState, FC } from "react";
import { Button, Form, message, Modal, Tooltip, Upload } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel, { } from "@/model/navModel";
import { usePurchaseRoModel } from "../../purchaseRoModel";
import { globalPrompt } from "@/components/message";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailsModel"
import { ITopType, ISelectOptions } from "@/types/ScmTypes";
import { DetailType } from "@/types/ScmEnums";
import { debounce } from "lodash";
import FontIcon from "@/components/YhIcon";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { UploadOutlined } from "@ant-design/icons";
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import { fileDownload } from "@/utils/exportFile";
import { Image } from 'antd';
import { YHDetailNav } from "@/components/YHDetailNav";
import { warehouseService } from "@/views/base/warehouse/warehouseService";

export const FormBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const {
        setSelectedRowKeys,
        setDescRows,
        setSelectedRow
    } = usePurchaseRoModel();
    const {
        detailAddList, detailDataSource,
        detailEditForm,
        detailAddForm,
        detailLookForm,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        insertDetail,
        editDetail,
        setDetailAddForm,
        setDetailAddList,
        setTopButsControl,
        setSupplierHistoryModel,
        setSupplierHistoryVisible,
        formComputeRule,
        setDetailDataSource,
        initForm,
        warehouseData, setWarehouseData,
        saveLoading, setSaveLoading, detailLookList, topButsControl, setSettleVisible, setWsConfirmModal
    } = usePurchaseRoDetailsModel();
    const { beShopDs, CustomerData, supplieAllList, shopAndOrg: { shopId, shopCode, shopName, shopType }, allShopDs } = useGlobalModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { getSelectedDictOne } = useDictModel();
    const [addPayMethodOptions, setAddPayMethodOptions] = useState<ISelectOptions[]>(getSelectedDictOne(DictCodeEnmu.PAY_METHOD))//新增根据结算类型展示结算方式
    const [editPayMethodOptions, setEditPayMethodOptions] = useState<ISelectOptions[]>(getSelectedDictOne(DictCodeEnmu.PAY_METHOD))//编辑根据结算类型展示结算方式

    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode);
            getDetailEditOne(id, mode)
        }
        if (mode === DetailType.add) {
            const params = {
                pageSize: 10000,
                pageNum: 1,
                shopId: shopId,
            }
            warehouseService.page(params).then(res => {
                const { retData } = res;
                setWarehouseData({ ...warehouseData, add: retData.records })
            })
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("11-3-1") && resetAddCatch(mode);
            !findNav("11-3-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])

    const save = () => {
        if (!formComputeRule(mode)) return;

        IFormRef.current?.validateFields().then(async res => {
            const { fileList = [], ...val } = res
            if (fileList.length > 0) {
                const file = fileList[0]
                if (!file?.uid) {
                    console.log(file)
                    return message.error('文件信息有误，请重新上传文件')
                }
                val.md5 = file?.uid
                val.fileName = file?.name
            } else {
                val.md5 = ''
                val.fileName = ''
            }
            if (mode === "add") {
                const resData = await insertDetail(val)
                if (resData) {
                    globalPrompt("message", { text: "新增成功", type: "success" });
                    resetAddCatch(mode);
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                    goBack();
                }
            } else if (mode === "edit") {
                let { id, returnCode } = detailEditForm
                const resData = await editDetail({ ...val, id, returnCode })
                if (resData) {
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    getDetailEditOne(returnCode as string, mode)
                }
            }
        })
    }
    const goBack = () => {
        replaceNav(selectedNavId, "11-3")
    }
    const onRefresh = async () => {
        if (mode === 'add') {
            IFormRef.current?.resetFields()
            setDetailAddForm(initForm)
            setDetailAddList([])

        } else if (mode === 'edit') {
            getDetailEditOne(id, mode)
        }
        message.success("刷新成功")
    }
    const controlEditable = () => {
        if (mode === DetailType.look) return false
        if (mode === DetailType.edit &&
            detailEditForm.status === DictCodeEnmu.PURCHASE_RETURN_STATUS_SETTLE ||
            detailEditForm.status === DictCodeEnmu.PURCHASE_RETURN_STATUS_STOCK_IO || detailEditForm.status === "purchase-return.paying") {
            return false
        }
        return true
    }
    const onWhConfirm = async () => {
        let materialNames: string[] = []
        let typeList = {
            add: [],
            edit: detailDataSource,
            look: detailLookList
        }
        await typeList[mode].forEach(item => {
            if (!!!item.shelfCode && !!!item.warehouseCode) {
                materialNames.push(item.materialName as string)
            }
        })
        if (materialNames.length === 0 && typeList[mode].length != 0) {
            await setWsConfirmModal(true)
        } else {
            await globalPrompt("message", { type: "error", text: `请选择商品${materialNames.toString()}的仓库与货位` })
        }
    }
    const rightChildren = <>
        {
            mode === "edit" && <>
                <YhAuth resCode={ResourceAuthEnum.P_R_ED_CONFIRM_BILL}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        disabled={topButsControl || detailEditForm.status === "purchase-return.settle" || detailEditForm.status === "purchase-return.stock-io"}
                        onClick={() => setSettleVisible(true)}
                    >确认结算</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.P_R_ED_STOCK}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        disabled={topButsControl || detailEditForm.status === "purchase-return.stock-io" || detailEditForm.status === "purchase-return.paying"}
                        onClick={onWhConfirm}
                    >确认出库</Button>
                </YhAuth>
            </>
        }
        {
            mode === "look" && <>
                <YhAuth resCode={ResourceAuthEnum.P_R_ED_CONFIRM_BILL}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        disabled={topButsControl}
                        onClick={() => setSettleVisible(true)}
                    >结算查看</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.P_R_ED_STOCK}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        disabled={topButsControl}
                        onClick={onWhConfirm}
                    >入库查看</Button>
                </YhAuth>

            </>
        }
        {controlEditable() &&
            <YhAuth resCode={ResourceAuthEnum.P_R_ED_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { save() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>
        }
        {mode !== "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onRefresh}
        >刷新</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    //采购实体
    const benttityChange = (value: string, option: ISelectOption) => {
        option && onChange({ bentityName: option.label, bentityCode: option.value });
        mode === 'edit' ? setDetailDataSource([]) : setDetailAddList([])
    }
    //供应商
    const supplieChange = (value: string, option: ISelectOption) => {
        option && onChange({ supplierName: option.label, supplierCode: option.value });
        mode === 'edit' ? setDetailDataSource([]) : setDetailAddList([])
    }
    //发票类型
    const invoiceChange = (value: string, option: ISelectOption) => {
        option && onChange({ invoiceTypeName: option.label, invoiceTypeCode: option.value });
    }
    //所属站点
    const shopNameChange = async (value: string, option: ISelectOption) => {
        const params = {
            pageSize: 10000,
            pageNum: 1,
            shopId: option.value,
        }
        let { retData } = await warehouseService.page(params);
        const { records, ...pg } = retData;
        setWarehouseData({ ...warehouseData, add: records })
        setDetailAddList([])
        option && onChange({ shopId: option.value, shopCode: option.code, shopName: option.label });
    }

    //结算方式
    const payMethodChange = (value: string, option: ISelectOption) => {
        option && onChange({ deliveryMethodName: option.label, deliveryMethod: option.value });
    }
    const documentChange = (value: string, option: ISelectOption) => {
        option && onChange({ documentTypeName: option.label, documentTypeCode: option.value });
    }
    const payMethodFocus = () => {
        // debugger;
        let newPayTypeVal = mode === "edit" ? detailEditForm.payType : detailAddForm.payType
        if (newPayTypeVal) {
            let newPayMethodOptions = getSelectedDictOne(DictCodeEnmu.PAY_METHOD).filter((item: any) => {
                if (item.relationvalue === newPayTypeVal) {
                    return item
                }
            })
            mode === "edit" ? setEditPayMethodOptions(newPayMethodOptions as ISelectOptions[]) : setAddPayMethodOptions(newPayMethodOptions as ISelectOptions[])
        }
    }
    const typeForm = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    const onConsumption = () => {
        let { supplierCode, supplierName } = typeForm[mode]
        if (!supplierCode) {
            return message.warning("请先选择供应商")
        }
        setSupplierHistoryVisible(true)
        setSupplierHistoryModel({ supplierName: supplierName as string })
    }
    const title = <>
        <span>基础信息</span>
        <Tooltip placement="topLeft" title="采购历史">
            <FontIcon type="icon-xiaofeijilu" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onConsumption}
            />
        </Tooltip>
        <a className="color-blue" style={{ float: 'right', fontSize: '17px' }} onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>
    </>
    const normFile = (e: UploadChangeParam) => {
        // let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
        // let isType: boolean = false
        // let fileEnd: string = e?.file.name.substring(e?.file.name.lastIndexOf('.'))
        // isType = filetypes?.includes(fileEnd) ?? false
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
                // e.fileList[e.fileList.length - 1] = data
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        // if (!isType) {
        //     e.fileList?.pop()
        // }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        // style: { padding: "18px 0 0 0", marginBottom: "15px" },
        // contentClass: "pr-77",
        // rightChildren,
        items: [
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "退货单号",
            //     fieldName: "returnCode",
            //     disable: true,
            //     placeholder: "自动生成"
            // },
            {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: <span>供应商名称</span>,
                fieldName: "supplierCode",
                options: transOptions(supplieAllList),
                onSelectChange: supplieChange,
                rules: [{ required: true, message: "请选择供应商" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "采购实体",
                fieldName: "bentityCode",
                options: beShopDs,
                onSelectChange: benttityChange,
                rules: [{ required: true, message: "请选择采购实体" }]
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "供应商类型",
                fieldName: "supplierTypeName",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "退货地址",
                fieldName: "returnAddress",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "所属站点",
                fieldName: "shopId",
                options: allShopDs,
                showSearch: false,
                onSelectChange: shopNameChange,
                rules: [{ required: true, message: "请选择所属站点" }],
                disable: shopType === 0 && mode == 'add' ? false : true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "shopName",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.INVOICE_TYPE),
                onSelectChange: invoiceChange,
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "结算类型",
                fieldName: "payType",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                rules: [{ required: true, message: "请输入结算类型" }]
                // }, {
                //     type: FormItemTypeEnum.Select,
                //     allowClear: true,
                //     showSearch: true,
                //     fieldLabel: "结算方式",
                //     fieldName: "payMethodName",
                //     onSelectFocus: payMethodFocus,
                //     options: mode == "add" ? addPayMethodOptions : editPayMethodOptions,// getSelectedDictOne(DictCodeEnmu.PAY_METHOD),
                // rules: [{ required: true, message: "请输入结算方式" }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "单据类型",
                fieldName: "documentTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.PRETURN_TYPE),
                rules: [{ required: true, message: "采退类型" }],
                onSelectChange: documentChange,
                disable: (mode === "edit" && !!detailDataSource.length) || (mode === "add" && !!detailAddList.length),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "退货原因",
                fieldName: "returnReason",
                // span: 5,
                // labelCol: { offset: 1 },
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
            },
            //  {
            //     type: FormItemTypeEnum.Button,
            //     fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
            //     fieldName: "",
            //     span: 1,
            //     labelCol: { offset: 5 },
            // },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单人",
                fieldName: "createUser",
                disable: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单时间",
                fieldName: "createTime",
                hidden: more,
                disable: true,
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "库管员",
                fieldName: "storekeeper",
                hidden: more,
                disable: true,
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出库时间",
                fieldName: "stockIoTime",
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算员",
                fieldName: "reckoner",
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算时间",
                fieldName: "settleTime",
                disable: true,
                hidden: more
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "核销时间",
                fieldName: "payTime",
                disable: true,
                hidden: more
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                hidden: mode == 'look' && !detailLookForm.md5 ? true : false,
                span: 12,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file: any) => {
                                // let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
                                // // let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                                // let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
                                // // var filetypes = [".jpg", ".png", ".rar", ".txt", ".zip", ".doc", ".ppt", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
                                // let isType = filetypes?.includes(fileEnd)
                                // if (!isType) {
                                //     message.error('不支持该格式的上传,当前仅支持 图片、pdf和.doc 类型文件')
                                // }
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                    file.status = 'done'
                                }
                                // return isType && isLt20M
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )

                            }}
                        >
                            {mode !== 'look' &&
                                <>
                                    <Button icon={<UploadOutlined />} >选择文件上传</Button>
                                    <span style={{ lineHeight: '25px', color: 'green', fontSize: '13px', marginLeft: '10px' }}>提醒：上传单个文件不能超过20M,当前仅.jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc等任何类型文件</span>
                                </>}
                        </Upload>
                    </Form.Item>
                ),
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购实体名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商名称",
                fieldName: "supplierName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商类型code",
                fieldName: "supplierTypeCode",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型名称",
                fieldName: "invoiceTypeName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采退类型名称",
                fieldName: "documentTypeName",
                hidden: true
            }
        ]
    };



    const onChange = (changedValues: { [key: string]: any }) => {
        let newChangedValues = changedValues;
        if ("supplierCode" in changedValues && changedValues.supplierCode) {
            let { name, typeCode, typeName, contact, phone } = getFindItem(changedValues.supplierCode as string, supplieAllList)
            newChangedValues = { ...changedValues, contact, phone, supplierName: name, supplierTypeCode: typeCode, supplierTypeName: typeName }
        }
        mode === "add" ? updateAddFormVal(newChangedValues) : updatEditFormVal(newChangedValues)
        setTopButsControl(true)
    }

    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: !controlEditable(),
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        采购退货单:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode].returnCode ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}